import request from '@/utils/request'

// 供应商列表
export function getAssignSupplierList(params) {
    return request({
        url: '/ums/admin/supplier/list',
        method: 'get',
        params
    })
}

// 供应商列表
export function getAssignedList(adminId) {
    return request({
        url: `/ums/admin/supplier/assigned/list/${adminId}`
    })
}

// 分配供应商
export function assignSupplier(adminId, data) {
    return request({
        url: `/ums/admin/supplier/assign/${adminId}`,
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/ums/assign-supplier.js